import { computeComparisonTimePeriod, getLastWeek, buildCustomDateRangeDisplayName } from 'src/utils/dateformatting';
import { getStartAndEndOfWeek } from 'src/utils/dateUtils';
import { useAppSelector } from 'src/utils/Hooks/typedHooks';
import { useRetailerId } from 'src/utils/Hooks/reduxSelectors';

interface TimePeriod {
  weekId: number;
  startWeek: number;
  endWeek: number;
  displayName: string;
}

interface UseLastWeekReturn {
  comparisonTimePeriod: TimePeriod;
  mainTimePeriod: TimePeriod;
}

/**
 * Hook that returns the current week as mainTimePeriod and the previous week as comparisonTimePeriod
 * Useful for week-over-week comparisons in analytics and reporting
 */
export const useLastWeek = (): UseLastWeekReturn => {
  const retailerId = useRetailerId();
  const allWeekIdsByRetailerId = useAppSelector((state) => state.allWeekIdsByRetailerId);
  const weekIds = allWeekIdsByRetailerId[retailerId];
  const comparisonTimeSelection = useAppSelector((state) => state.comparisonTimePeriod.id);
  const lastWeekId = getLastWeek(weekIds);

  const comparisonTimePeriod = computeComparisonTimePeriod(
    weekIds,
    {
      startWeek: lastWeekId,
      endWeek: lastWeekId
    },
    comparisonTimeSelection
  );

  const { startDate, endDate } = getStartAndEndOfWeek(lastWeekId);

  const mainTimePeriod = {
    weekId: lastWeekId,
    startWeek: lastWeekId,
    endWeek: lastWeekId,
    displayName: buildCustomDateRangeDisplayName(startDate, endDate)
  };

  return {
    comparisonTimePeriod,
    mainTimePeriod
  };
};

export default useLastWeek;